export default {"src":"/_next/static/media/startups.903e4464.svg","height":36,"width":36};